import resolver from 'js-promo-partners-lib/lib/services/app-urls-resolver/app-urls-resolver';
import getConfig from '../config';

const { appPrefix, appHost } = getConfig();

const appUrlsResolver = resolver({
    prefix: appPrefix,
    host: appHost,
    includeHost: true,
});

export default appUrlsResolver;
